const selectors = {
  header: '#header',
  navBar: '.nav-bar',
  megaMenu: '.header__mega-menu',
  megaMenuTriggers: '[data-trigger="megaMenu"]',
  catTriggers: '.mega-menu__links__category-trigger',
  activeTrigger: '.mega-menu__links__category-trigger[data-active="true"]',
  desktopMenu: '.desktop-menu'
};

import hoverintent from 'hoverintent'


export default function init ({ el, context }) {

  const nodeSelectors = {
    header: document.querySelector(selectors.header),
    navBar: document.querySelector(selectors.header),
    megaMenu: document.querySelector(selectors.megaMenu),
    megaMenuTriggers: document.querySelectorAll(selectors.megaMenuTriggers),
    catTriggers: document.querySelectorAll(selectors.catTriggers),
    desktopMenu: document.querySelector(selectors.desktopMenu)
  };

  const toggleMenu = (panelHandle, offset) => {
    var activePanel = nodeSelectors.megaMenu.querySelector(`[data-panel-active]`)
    if(activePanel){
      activePanel.style.display = "none"
      activePanel.removeAttribute('data-panel-active', true)
    }
    var panel = nodeSelectors.megaMenu.querySelector(`[data-mega-menu-panel="${panelHandle}"]`)
    panel.style.display = 'flex'
    panel.setAttribute('data-panel-active', true)

    //panel.style.paddingLeft = `${offset - 80}px`

  }

  const initEvents = () => {
    for (var i = nodeSelectors.catTriggers.length - 1; i >= 0; i--) {
      nodeSelectors.catTriggers[i].addEventListener('click', (event) => {  
        event.preventDefault();
        var categoryName = event.currentTarget.dataset.category
        var categoryElement = document.querySelector(`.header__mega-menu__links__category[data-category="${categoryName}"]`)
        var activeCat = document.querySelector(`.header__mega-menu__links__category[data-active="true"]`)
        if (activeCat) activeCat.setAttribute('data-active', false);
        if (categoryElement) categoryElement.setAttribute('data-active', true);
        let oldLink = document.querySelector(selectors.activeTrigger)
        if (oldLink) oldLink.setAttribute('data-active', false);
        let thisLink = event.currentTarget
        thisLink.setAttribute('data-active', true)
      });
    }
  }

  const scrollOffMegaMenu = () => {
    nodeSelectors.header.addEventListener("mouseover", (event) => {
      if (event.target === nodeSelectors.header) closeMegaMenu();
    })
  };

  const closeMegaMenu = () => {
    nodeSelectors.megaMenu.setAttribute("aria-hidden", true);
    nodeSelectors.header.classList.remove("overlayed");
    nodeSelectors.megaMenuTriggers.forEach((btn) => {
      btn.classList.remove("active-menu-trigger");
    });
    
  };

  const initMenuTriggers = () => {
    for (var i = nodeSelectors.megaMenuTriggers.length - 1; i >= 0; i--) {
      hoverintent(nodeSelectors.megaMenuTriggers[i], (e) => {
        var thisButton = e.target
        var offset = thisButton.offsetLeft
        var panelHandle = thisButton.dataset.panelHandle
        var thisButtonActive = thisButton.classList.contains('active-menu-trigger')
        var alreadyOverlayed = nodeSelectors.header.classList.contains('overlayed')
        
          if (!thisButtonActive) {
            var currentActive = document.querySelector(".active-menu-trigger");
            if (currentActive) {
              currentActive.classList.remove("active-menu-trigger");
            }
            thisButton.classList.add("active-menu-trigger");

            if (alreadyOverlayed === false) {
              nodeSelectors.header.classList.add("overlayed");
            }
            toggleMenu(panelHandle, offset);
            nodeSelectors.megaMenu.setAttribute("aria-hidden", false);
          }
      }, () => {

      });
    }
  }
  
  const initDoshaQuizMenuBtn = () => {
    hoverintent(nodeSelectors.desktopMenu.lastChild, () => {
      closeMegaMenu();
    })
  };

  scrollOffMegaMenu();
  initMenuTriggers();
  initDoshaQuizMenuBtn();
  initEvents();

  function rePaintNav() {
    const currentUrl = window.location.href;
    const docRootStyle = document.documentElement.style;

    if (currentUrl.indexOf("/blogs/research") > -1) {
      docRootStyle.setProperty( "--nav-background-color", "var(--bg-color-blog-research)" );
      docRootStyle.setProperty( "--bg-color-mega-menu", "var(--bg-color-blog-research-mega-menu)" );

    } else if (currentUrl.indexOf("/blogs/article") > -1) {
      docRootStyle.setProperty( "--nav-background-color", "var(--bg-color-blog-article)" );
      docRootStyle.setProperty( "--bg-color-mega-menu", "var(--bg-color-blog-article-mega-menu)" );

    } else if (currentUrl.indexOf("/blogs/recipe") > -1) {
      docRootStyle.setProperty( "--nav-background-color", "var(--bg-color-blog-recipe)" );
      docRootStyle.setProperty( "--bg-color-mega-menu", "var(--bg-color-blog-recipe-mega-menu)" );

    } else if (currentUrl.indexOf("/blogs/video") > -1) {
      docRootStyle.setProperty( "--nav-background-color", "var(--bg-color-blog-video)" );
      docRootStyle.setProperty( "--bg-color-mega-menu", "var(--bg-color-blog-video-mega-menu)" );
    }
  }
  
  window.addEventListener('load', () => {
    rePaintNav();
  })
}